import { type ButtonHTMLAttributes } from 'react';
import { IoArrowBack } from 'react-icons/io5';
import './BackButton.css';

export interface BackButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
}

export default function BackButton({ onClick, className = '', ...props }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`back-button ${className}`.trim()}
      aria-label="Назад"
      {...props}
    >
      <IoArrowBack size={20} />
    </button>
  );
}

